import { 
	UpgradePageContainer,
	UpgradePageRoot,
} from './UpgradePage.styled';
import { HeroSectionVideo } from './HeroSectionVideo';
import { UpgradePagesTiles } from './UpgradePagesTiles';
import { CustomerQuote } from './CustomerQuote';
import { SectionVideo } from './VideoSection';
import { IconPosition } from '../button/ButtonVariant';

interface Props {
	pageType?: 'reports' | 'reward_store' | 'dashboards' | 'integrations';
	// HeroSectionVideo props
	heading: string;
	mainText: string;
	subtext: string;
	videoUrl: string;
	isAdmin: boolean;
	upgradePage: {
		featureName: string;
		slug: string;
		hubspotEmail: string;
		hubspotCountry: string;
		hubspotIndustry: string;
		hubspotLink: string;
		upgradePageLink: string;
		subscription: {
			name: string;
			uuid: string;
		};
		alreadyTried: boolean;
	};
	modal: {
		modalTitle: string;
		modalSubtitle: string;
		modalContentHeader: string;
		redirectUrl: string;
		tiles: Array<{
			icon: string;
			tileTitle: string;
			tileDescription: string;
			isFullWidth: boolean;
			isHorizontal: boolean;
		}>;
	};
	primaryButtonLabel: string;
	secondaryButtonLabel: string;
	primaryButtonLabelTried: string;
	primaryButtonLabelModal: string;
	secondaryButtonLabelModal: string;
	position?: 'left' | 'right';
	showBorder?: boolean;
	isVimeo?: boolean;

	// UpgradePagesTiles props
	tilesHeaderTitle?: string;
	tilesHeaderTitleColored?: string;
	headerTitlePosition?: IconPosition;
	featureTiles: Array<{
		icon: string;
		tileTitle: string;
		tileDescription: string;
		isFullWidth?: boolean;
		isHorizontal?: boolean;
	}>;

	// CustomerQuote props
	customerQuote: {
		logo: string;
		quote: string;
		author: string;
		jobTitle: string;
		learnMoreLink: string;
		learnMoreLinkLabel: string;
		learnMoreLinkTarget: boolean;
		readMoreLink: string;
		readMoreLinkLabel: string;
		readMoreLinkTarget: boolean;
		readMoreLinkHelper: string;
		backgroundColor?: string;
		vectorUrl: string;
	};

	// Add new prop for second video
	secondaryVideoUrl?: string;
	secondaryIsVimeo?: boolean;

	// New props for onFeatureTrialStart and isSubmitting
	onFeatureTrialStart?: () => Promise<void>;
	isSubmitting?: boolean;
}

export const UpgradePage = ({ 
	// HeroSectionVideo props
	heading,
	mainText,
	subtext,
	videoUrl,
	isAdmin,
	upgradePage,
	modal,
	primaryButtonLabel,
	secondaryButtonLabel,
	primaryButtonLabelTried,
	primaryButtonLabelModal,
	secondaryButtonLabelModal,
	position,
	showBorder,
	isVimeo,
	// UpgradePagesTiles props
	tilesHeaderTitle,
	tilesHeaderTitleColored,
	featureTiles,
	headerTitlePosition,
	// CustomerQuote props
	customerQuote,
	secondaryVideoUrl,
	secondaryIsVimeo = false,
	// New props
	onFeatureTrialStart,
	isSubmitting = false,
}: Props) => {
	return (
		<UpgradePageRoot>
			<UpgradePageContainer>
				<HeroSectionVideo
					upgradePageLink={upgradePage.upgradePageLink}
					heading={heading}
					mainText={mainText}
					subtext={subtext}
					videoUrl={videoUrl}
					isAdmin={isAdmin}
					upgradePage={upgradePage}
					modal={modal}
					primaryButtonLabel={primaryButtonLabel}
					secondaryButtonLabel={secondaryButtonLabel}
					primaryButtonLabelTried={primaryButtonLabelTried}
					primaryButtonLabelModal={primaryButtonLabelModal}
					secondaryButtonLabelModal={secondaryButtonLabelModal}
					position={position}
					showBorder={showBorder}
					isVimeo={isVimeo}
					hubspotEmail={upgradePage.hubspotEmail}
					hubspotCountry={upgradePage.hubspotCountry}
					hubspotIndustry={upgradePage.hubspotIndustry}
					hubspotLink={upgradePage.hubspotLink}
					onFeatureTrialStart={onFeatureTrialStart}
					isSubmitting={isSubmitting}
				/>

				{secondaryVideoUrl && (
					<SectionVideo
						videoUrl={secondaryVideoUrl}
						showBorder={false}
						isVimeo={secondaryIsVimeo}
					/>
				)}

				<UpgradePagesTiles
					headerTitle={tilesHeaderTitle}
					headerTitleColored={tilesHeaderTitleColored}
					headerTitlePosition={headerTitlePosition}
					tiles={featureTiles}
				/>

				<CustomerQuote {...customerQuote} />
			</UpgradePageContainer>
		</UpgradePageRoot>
	);
};
